module.exports = __webpack_public_path__ + "static/simple-histogram-8e5133a53c4c1369369d85c46d630ff6.png";